var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Shop extends Component {
    constructor() {
        super('Shop', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            /*$('.woocommerce-cart .qty').on('change', (event: Event, select: Collection) => {
              setTimeout(() => {
                $('button[name="update_cart"]').get(0).submit();
              }, 1000);
            });*/
            let timeout;
            $(document.body).on(['change', 'input'], 'input.qty', function () {
                clearTimeout(timeout);
                timeout = window.setTimeout(function () {
                    $('.woocommerce-cart-form').append($.parseHTML('<input type="hidden" name="update_cart" value="Update cart" />'));
                    $('.woocommerce-cart-form').get(0).submit();
                }, 500);
            });
            this.success();
        });
    }
}
